/**
 * Enum for draft steps
 */
export enum DRAFT_STEP {
  TRACK = 'track_step_done',
  SHARED_MUSIC = 'shared_music_step_done',
  CURATORS = 'curators_selection_step_done',
  MESSAGE = 'message_step_done',
  RECAP = 'recap_step_done',
}

export const DRAFT_STEP_URL = {
  [DRAFT_STEP.TRACK]: 'track/',
  [DRAFT_STEP.SHARED_MUSIC]: 'shared-music/',
  [DRAFT_STEP.CURATORS]: 'influencers/',
  [DRAFT_STEP.MESSAGE]: 'messages/',
  [DRAFT_STEP.RECAP]: 'recap/',
}

export const DRAFT_STEP_ORDER = [
  DRAFT_STEP.TRACK,
  DRAFT_STEP.CURATORS,
  DRAFT_STEP.MESSAGE,
  DRAFT_STEP.RECAP,
]

/**
 * Map of draft steps to the progress bar steps
 */
export const PROGRESS_BAR_STEP_MAP = {
  [DRAFT_STEP.TRACK]: 1,
  [DRAFT_STEP.SHARED_MUSIC]: 2,
  [DRAFT_STEP.CURATORS]: 2,
  [DRAFT_STEP.MESSAGE]: 3,
  [DRAFT_STEP.RECAP]: 4,
}
